import React from "react";
import TourListItem from "../TourListItem";
import { Router, Helpers } from "../Helpers";
import { Waypoint } from 'react-waypoint';
import { trackWindowScroll } from 'react-lazy-load-image-component';
import { useMediaQuery } from '@react-hook/media-query';

function TourList({
    tours,
    env,
    routes,
    active_site,
    location,
    cart,
    tourListingCtaText,    
    specific_tours,
    scrollPosition, //for lazy loading tour images
    onImpressionChange = (f) => f,
    onProductClick = (f) => f,
}) {

    const isMobileScreen = useMediaQuery('only screen and (max-width: 600px)');
    
    function generateProductUrl(tour) {
        const router = Router(routes);

        let params = {
            domain: active_site.domain,
            id: tour.id,
            tour_slug: tour.slug,
        };

        if (!_.isEmpty(location.region_slug)) {
            params.region_slug = location.region_slug;
            params.country_slug = location.country_slug;

            return specific_tours ? router.url("specific_tours.show_region", params) : router.url("tours.show_region", params);
        }

        if (!_.isEmpty(location.country_slug)) {
            params.country_slug = location.country_slug;

            return specific_tours ? router.url("specific_tours.show_country", params) : router.url("tours.show_country", params);
        }
    }

    function inCart(tour) {
        return _.findIndex(cart.items, (_item) => tour.name == _item.name) > -1;
    }

    return (
        <div className="tour-list">
            {tours.map((tour, key) => {
                const product_url = generateProductUrl(tour);

                let pricingType = _.find(tour.tags.data, (_tag) => {
                    return _tag.tag_group_name === "Pricing Type";
                });
                pricingType = !_.isEmpty(pricingType)
                    ? pricingType.name
                    : "per person";

                return (
                    <Waypoint
                        key={key}
                        onEnter={() => onImpressionChange(tour, key + 1)}
                    >
                        <div className="row mb-4">
                            <div className="col-12">
                                <TourListItem
                                    tour={tour}
                                    onClick={(tour, event) =>onProductClick(tour, key + 1, event)}
                                    productUrl={product_url}
                                    image={tour.cover_photo && tour.cover_photo.medium}
                                    isInCart={inCart(tour)}
                                    price={
                                        env.CURRENCY +
                                        " " +
                                        Helpers.formatNoDecimalCurrency(
                                            tour.price
                                        )
                                    }
                                    pricingType={_.upperCase(pricingType)}
                                    tourListingCtaText={tourListingCtaText}
                                    scrollPosition={scrollPosition}
                                    specific_tours={specific_tours}
                                    lazy={isMobileScreen}
                                />
                            </div>
                        </div>
                    </Waypoint>
                );
            })}
        </div>
    );
}

export default trackWindowScroll(TourList);



// WEBPACK FOOTER //
// ./resources/js/components/TourList/index.js